import { ref } from "vue"
export const hideClass = ref<{ [key: string]: string | number | boolean }>({})
export const showClass = ref<{ [key: string]: string | number | boolean }>({})
